import { 
    ScatterChart,
    LineChart,
    AreaChart,
    BarChart,
    ComposedChart,
    PieChart,
    RadarChart,
    RadialBarChart,
    FunnelChart,
    Treemap,
    Sankey,
} from "recharts"
import { CustomLineChart } from "../components/TypeChart/CustomLineChart"

export const ChartType = {
    AreaChart: 'area-chart',
    BarChart: 'bar-chart',
    LineChart: 'line-chart',
    ComposedChart: 'composed-chart',
    PieChart: 'pie-chart',
    RadarChart: 'radar-chart',
    RadialBarChart: 'radial-bar-chart',
    ScatterChart: 'scatter-chart',
    FunnelChart: 'funnel-chart',
    Treemap: 'tree-map',
    SankeyChart: 'sankey-chart',
}

export const LineType = [
    'basis',
    'bump',
    'linear',
    'natural',
    'monotone',
    'step',
]

export const LineTypeObj = {
    basis: "обычный",
    bump: "сглажено - ступенчатый",
    linear: 'линейный',
    natural: "сглажено - линейный",
    monotone: "монотонный",
    step: "ступенчатый",
}

export const LegendType = [
    'line', 'plainline',  'square',  'rect',  'circle',  'cross',  'diamond',  'square',  'star',  'triangle',  'wye',  'none',
]

export const animationType = [
    'ease',  'ease-in',  'ease-out',  'ease-in-out',  'linear',
]


export const ChartOptions = (initialValue, data, line, label, setFieldValue, variable, value) => {
    switch(initialValue.type) {
        case ChartType.AreaChart:
            return <AreaChart />
        case ChartType.BarChart:
            return <BarChart />
        case ChartType.LineChart:
            return CustomLineChart(initialValue, data, line, label, setFieldValue, variable, value)
        case ChartType.ComposedChart:
            return <ComposedChart /> 
        case ChartType.PieChart:
            return <PieChart />
        case ChartType.RadarChart:
            return <RadarChart />
        case ChartType.RadialBarChart:
            return <RadialBarChart />
        case ChartType.ScatterChart:
            return <ScatterChart />     
        case ChartType.FunnelChart:
            return <FunnelChart />
        case ChartType.Treemap:
            return <Treemap />
        case ChartType.SankeyChart:
            return <Sankey />      
        default:
            return null 
    }
}